<template>
  <div class="ai-portrait-container">
    <!-- 主内容区域 -->
    <div class="main-content">
      <!-- 顶部按钮组 -->
      <div class="button-group">
        <button v-for="button in mainButtons" :key="button.id" class="main-button"
          :class="{ active: activeMainButton === button.id }" @click="handleMainButtonClick(button.id)">
          {{ button.label }}
        </button>
      </div>




      <!-- 内容区域 -->
      <div class="content-area">
        <!-- 图库管理内容 -->
        <MaterialGallery v-if="activeMainButton === 'image'" />

        <!-- 商户管理内容 -->
        <MerchantManagement v-else-if="activeMainButton === 'merchant'" />

        <PortraitManagement v-else-if="activeMainButton === 'portrait'" />

        <!-- 关键词管理内容 -->
        <div v-else-if="activeMainButton === 'keywords'" class="keywords-content">
          <KeywordManagement />
        </div>


        <SystemConfig v-else-if="activeMainButton === 'system'" />

      </div>
    </div>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus'
import MaterialGallery from '@/components/MaterialGallery.vue'
import MerchantManagement from '@/components/MerchantManagement.vue'
import PortraitManagement from '@/components/PortraitManagement.vue'
import KeywordManagement from '@/components/KeywordManagement.vue'
import SystemConfig from '@/components/SystemConfig.vue'

export default {
  name: 'AiPortrait',
  components: {
    MaterialGallery,
    MerchantManagement,
    PortraitManagement,
    KeywordManagement,
    SystemConfig
  },
  data() {
    return {
      activeMainButton: 'keywords',
      activeSubButton: 'search',
      // 主按钮配置
      mainButtons: [
        { id: 'keywords', label: '添加关键词' },
        { id: 'portrait', label: '添加画像' },
        { id: 'image', label: '添加图片' },
        { id: 'merchant', label: '添加商户' },
        { id: 'system', label: '系统配置' }  // 新增
      ]
    }
  },
  methods: {
    handleMainButtonClick(buttonId) {
      this.activeMainButton = buttonId
      if (buttonId !== 'keywords') {
        this.activeSubButton = null
      } else {
        this.activeSubButton = 'search'
      }
    },

    handleSubButtonClick(subButtonId) {
      this.activeSubButton = subButtonId
    },


    handleAddAction(type) {
      // 这些功能现在由各自组件内部处理
      if (type === 'keywords' || type === 'portrait') {
        ElMessage.info(`正在添加${this.getMainButtonLabel(type)}...`)
      }
      // image 和 merchant 的添加功能在各自组件内部
    },

    getMainButtonLabel(type) {
      const button = this.mainButtons.find(b => b.id === type)
      return button ? button.label : ''
    },


    getAddButtonLabel(type) {
      return `添加${this.getMainButtonLabel(type).replace('添加', '')}`
    },

    getContentTitle() {
      if (this.activeMainButton === 'keywords' && this.activeSubButton) {
        return this.getSubButtonLabel(this.activeSubButton)
      }
      return this.getMainButtonLabel(this.activeMainButton)
    }
  }
}
</script>

<style scoped lang="scss">
.ai-portrait-container {
  padding: 24px;
  min-height: calc(100vh - 160px);
  background: transparent;
}

.main-content {
  background: hsla(0, 0%, 100%, .1);
  border-radius: 16px;
  padding: 24px;
  backdrop-filter: blur(10px);
}

.button-group {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.main-button {
  padding: 12px 24px;
  background: hsla(0, 0%, 100%, .1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: #e0e6ff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #ff7048;
    border-color: #ff7048;
    transform: translateY(-2px);
  }

  &.active {
    background: #ff7048;
    border-color: #ff7048;
  }
}

.sub-button-group {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  align-items: center;
  flex-wrap: wrap;
}

.sub-button {
  padding: 8px 16px;
  background: hsla(0, 0%, 100%, .1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  color: #e0e6ff;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #ff7048;
    border-color: #ff7048;
  }

  &.active {
    background: #ff7048;
    border-color: #ff7048;
  }

  &.keyword-sub-button {
    background: #ff7048;
    border-color: #ff7048;

    &:hover {
      background: #e55a3a;
      border-color: #e55a3a;
    }
  }

  &.orange-button {
    background: #ff7048;
    border-color: #ff7048;

    &:hover {
      background: #e55a3a;
      border-color: #e55a3a;
    }
  }
}

.instruction-button {
  padding: 8px 16px;
  background: transparent;
  border: 1px solid #ff7048;
  border-radius: 6px;
  color: #ff7048;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 112, 72, 0.1);
  }
}

.content-area {
  min-height: 400px;
}

// 关键词内容样式
.keywords-content,
.other-content {
  .feature-card {
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(110, 33, 254, 0.2);
    border-radius: 16px;

    :deep(.el-card__header) {
      background: rgba(110, 33, 254, 0.1);
      border-bottom: 1px solid rgba(110, 33, 254, 0.2);
      border-radius: 16px 16px 0 0;
      padding: 20px;
    }

    .card-header {
      .card-title {
        color: #6e21fe;
        font-weight: 600;
        font-size: 18px;
      }
    }

    .card-content {
      padding: 60px 20px;
      text-align: center;

      p {
        color: #a0a8b8;
        font-size: 16px;
        margin: 0 0 16px 0;
        line-height: 1.6;
      }

      .demo-data {
        color: #ff7048;
        font-weight: 600;
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .ai-portrait-container {
    padding: 16px;
  }

  .button-group {
    gap: 12px;

    .main-button {
      padding: 10px 20px;
      font-size: 13px;
    }
  }

  .sub-button-group {
    gap: 8px;

    .sub-button,
    .instruction-button {
      padding: 6px 12px;
      font-size: 12px;
    }
  }
}

@media (max-width: 480px) {
  .main-content {
    padding: 16px;
  }

  .button-group {
    justify-content: center;
  }

  .sub-button-group {
    justify-content: center;
  }
}

:deep(.portrait-dialog .el-dialog__header) {
  background: transparent !important;
}
</style>